import { Injectable } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import {EmailPasswordCredentials} from '../models/email-password-credentials'
import {Constants} from '../config/Constants'
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { UtilityService } from './utility.service';
import { ExtraService } from './extra.service';
import { firebase } from '@firebase/app';
@Injectable()
export class AuthService {
  authState: any = null;
  constructor(private extraService :ExtraService,private afAuth: AngularFireAuth,private router: Router,private utilityService:UtilityService) { 
    this.afAuth.authState.subscribe((auth) => {
      this.authState = auth
    });
  }

  loginUser(emailPasswordCredentials :EmailPasswordCredentials) {
    return this.afAuth.auth.signInWithEmailAndPassword(emailPasswordCredentials.email,emailPasswordCredentials.password);
  }

  loginWithGoogle(): Promise<any> {
   return this.afAuth.auth.signInWithPopup(new firebase.auth.GoogleAuthProvider());
  }
  
  resetPassword(email :string):Promise<any> {
    return this.afAuth.auth.sendPasswordResetEmail(email);
  }

  registerUser(email :string,password:string):Promise<any> {
    return this.afAuth.auth.createUserWithEmailAndPassword(email, password);
  }
  
  get authenticated(): boolean {
    return this.authState !== null;
  }

  getEmail(){
    return this.authenticated ? this.authState.uid : '';
  }

  logout(){
    this.afAuth.auth.signOut();
  }

}



// WEBPACK FOOTER //
// /app/src/app/core/services/auth.service.ts